import { i18n } from '@lingui/core';

export type QAQCReportPageParams = Readonly<Record<'pourId' | 'breakingScheduleId', string | undefined>>;

export const POUR_PARAM_IDENTIFIER = ':pourId';
export const BREAKING_SCHEDULE_PARAM_IDENTIFIER = ':breakingScheduleId';
export const ROUTE_PATH = `/qaqc/${POUR_PARAM_IDENTIFIER}/breaking-schedules/${BREAKING_SCHEDULE_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('QAQC Report');
